function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.960784 0 0 0 0 0.313725 0 0 0 0 0.294118 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "100-Homepage",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "100a_Homepage_Mobile_Design",
  transform: "translate(-311.000000, -5954.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Molecules-/-This-is-how-it-works-/-Mobile",
  transform: "translate(0.000000, 1107.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Molecules-/-Exercise-Summation-Copy",
  transform: "translate(15.000000, 4814.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: 6,
  transform: "translate(289.000000, 18.000000)",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.000000, 15.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.5,0 C13.462625,0 11,2.55857143 11,5.71428571 C11,2.55857143 8.537375,0 5.5,0 C2.462625,0 0,2.55857143 0,5.71428571 C0,10.9657143 2.8545,15.7657143 7.374125,18.1157143 L11,20 L14.62175,18.1185714 C19.144125,15.77 22,10.9671429 22,5.71571429 L22,5.71428571 C22,2.55857143 19.537375,0 16.5,0",
  id: "Fill-9",
  fill: "#231F20"
})))))));

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "20px",
    viewBox: "0 0 22 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "086887D7-5C17-4B67-A710-7F6AB60E4655") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.ebe3f883.svg";
export { ForwardRef as ReactComponent };